import { render, staticRenderFns } from "./PropertyButton.vue?vue&type=template&id=5dc41695&"
import script from "./PropertyButton.vue?vue&type=script&lang=js&"
export * from "./PropertyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports